import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const getFolderIdByName = async (folderName) => {
  try {
    const response = await axios.get(
      "https://www.googleapis.com/drive/v3/files",
      {
        params: {
          q: `name='${folderName}' and mimeType='application/vnd.google-apps.folder' and '1ff5JCYUYeBHZ_2q3iM8SL6vptJUQ7NPm' in parents`,
          key: window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API,
          fields: "files(id, name)",
          supportsAllDrives: true,
          includeItemsFromAllDrives: true,
        },
      }
    );

    const folders = response.data.files;
    if (folders.length > 0) {
      return folders[0].id;
    } else {
      throw new Error(`Folder '${folderName}' not found.`);
    }
  } catch (error) {
    console.error(
      "Error fetching folder ID:",
      error.response?.data || error.message
    );
    return null;
  }
};


const getFiles = async (folderName, setCaseFiles, setError) => {
  try {
    const folderId = await getFolderIdByName(folderName);
    if (!folderId) {return}
    const response = await axios.get(
      "https://www.googleapis.com/drive/v3/files",
      {
        params: {
          q: `'${folderId}' in parents`,
          key: window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API,
          fields: "files(id, name, webViewLink, mimeType)",
          supportsAllDrives: true,
          includeItemsFromAllDrives: true,
        },
      }
    );

    setCaseFiles(response.data.files);
  } catch (error) {
    console.error(
      "Error fetching files:",
      error.response?.data || error.message
    );
    setError("Error fetching files from Google Drive!");
    setTimeout(() => {
      setError(null);
    }, 2000);
  }
};

export default function CaseFile({ selectedCase, setError, caseFiles, setCaseFiles }) {
  // const [caseFiles, setCaseFiles] = useState([]);
  const [loading, setLoading] = useState(false)
  const [deleting, setDeleting] = useState(null)

  const uploadFile = async (file, caseId) => {
    setLoading(true)
    const formData = new FormData();
    formData.append("file", file);
    formData.append("case_id", caseId);

    try {
      const accessToken = localStorage.getItem("accessToken")
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}upload/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${accessToken}`
          },
        }
      );

      getFiles(selectedCase.casenumber, setCaseFiles, setError);

    } catch (error) {
      console.error("Upload failed:", error);
      setError("Error uploading file!")
    } finally {
      setLoading(false)
    }
  };

  const handleFileDelete = async (file_id) => {
    setDeleting(file_id)
    try {
      const accessToken = localStorage.getItem("accessToken")

      const response  = await axios.post(`${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}delete-file/`, {"file_id" : file_id, "case_id": selectedCase.caseid},
        {
          headers: {
            "Authorization": `Bearer ${accessToken}`
          }
        }
      )

      getFiles(selectedCase.casenumber, setCaseFiles, setError);

    } catch (error) {
      console.log(error)
      setError("Error deleting file!")

    } finally {
      setDeleting(null)
    }
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const caseId = selectedCase.caseid;
    await uploadFile(file, caseId);
    event.target.value = '';

  };



  return (
    <>
      <h5 className="uppercase text-[#ef8d23] font-bold">Case Files</h5>

      {caseFiles.length > 0 ? (
        caseFiles.map((file) => (
          <div className="flex justify-content-between">
          <Link
            to={file.webViewLink}
            target="_blank"
            className="mb-3"
            key={file.id}
          >
            <i className={`mx-[25px] fas fa-file-pdf align-middle`}></i>
            {file.name} {deleting === file.id && <><span className="text-[#dc3545]">Deleting</span><span className="upload loading"></span></>}
          </Link>
          <button className="mb-3" onClick={() => {
            handleFileDelete(file.id)
          }}><i class="fa-solid fa-trash ml-2 text-[#dc3545]"></i></button>
          </div>
        ))
      ) : (
        <p>No case files found.</p>
      )}

      <input type="file" onChange={handleFileChange} className="mt-3" />
      {loading && <><span className="text-[#ef8d23]">Uploading</span><span className="upload loading"></span></>}

    </>
  );
}
